
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import ResellerSalesReport from '@/components/masterlicense/ResellerSalesReport';

const MasterLicenseResellerSales = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    handleLogout,
    activeTab,
    setActiveTab
  } = useMasterLicense();

  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      activeTab="reseller-sales"
      userRole="Master Admin"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Reseller Sales and Invoices</h1>
          <p className="text-gray-600">
            Track sales, invoices, and recurring revenue from your reseller plans
          </p>
        </div>
        
        <ResellerSalesReport />
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicenseResellerSales;
